import { apiCall } from '../Shared/SharedServices';

export default {
    async login(username, password) {
        const url = `Authentication/Login`;
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify({ UserName: username, Password: password })
        };

        return await apiCall(url, requestOptions);
    },

    async clientSettings() {
        const url = `Authentication/ClientSettings`;
        const requestOptions = {
            method: 'GET'
        };

        return await apiCall(url, requestOptions);
    }
};